import React, { useState } from "react";

import { useMediaQuery, Divider, Tab, Tabs } from "@material-ui/core";

import {
  CreateButton,
  Datagrid,
  DateField,
  EditButton,
  List,
  RefreshButton,
  SimpleList,
  TextField,
  TopToolbar,
} from "react-admin";

import { isSubscriptionDisabled } from "../../../utils/appUtils";
import { ChevronRightIcon } from "../../../components/common/iconography";
import { Empty } from "../../../components/common/Empty";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { Pagination } from "../../../components/Pagination";
import { AuditStatus } from "../../../utils/constants";
import { AuditProgressBar } from "./AuditProgressBar";

const ListActions = ({ basePath, ...props }) => (
  <TopToolbar>
    <CreateButton basePath={basePath} disabled={isSubscriptionDisabled()} />
    <RefreshButton />
  </TopToolbar>
);

const tabs = [
  { id: AuditStatus.IN_PROGRESS, name: "In Progress", showSmall: true },
  { id: AuditStatus.PENDING_REVIEW, name: "Pending Review", showSmall: true },
  { id: AuditStatus.COMPLETED, name: "Completed", showSmall: false },
];

export const AuditList = (props) => {
  const [tabValue, setTabValue] = useState(
    sessionStorage.getItem("AuditsTab")
      ? sessionStorage.getItem("AuditsTab")
      : 0
  );

  const defaultSortOrder = { field: "createDateTime", order: "DESC" };
  const initFilterValues = {
    auditByStatusByDate: {
      reloadYardId: window.appUser?.reloadYardId,
      statusCreateDateTime: {
        beginsWith: { status: tabs[tabValue].id },
      },
    },
  };

  return (
    <List
      {...props}
      title={<ForceTitle title="Audits" />}
      filter={initFilterValues}
      sort={defaultSortOrder}
      actions={<ListActions {...props} />}
      bulkActionButtons={false}
      pagination={<Pagination />}
    >
      <AuditTabGrid {...props} tabValue={tabValue} setTabValue={setTabValue} />
    </List>
  );
};

const AuditTabGrid = ({ tabValue, setTabValue, ...props }) => {
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("md"));

  const handleChange = (event, value) => {
    sessionStorage.setItem("AuditsTab", value);
    setTabValue(value);
  };

  return (
    <>
      <Tabs
        value={Number(tabValue)}
        indicatorColor="primary"
        textColor="primary"
        onChange={handleChange}
      >
        {tabs.map(
          (itm, idx) =>
            (!isSmall || itm.showSmall) && (
              <Tab key={itm.id} label={itm.name} id={`audit-${idx}`} />
            )
        )}
      </Tabs>
      <Divider />
      {tabs.map(
        (itm) =>
          itm.id === tabs[tabValue].id && (
            <AuditGrid {...props} key={itm.id} tabValue={itm.id} />
          )
      )}
    </>
  );
};

const AuditGrid = ({ ids, tabValue, ...props }) => {
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const isXSmall = useMediaQuery((theme) => theme.breakpoints.down("xs"));

  if (tabValue === AuditStatus.IN_PROGRESS && ids.length === 0)
    return <Empty {...props} message="Create a new inventory audit" />;
  else
    return isXSmall ? (
      <SimpleList
        primaryText={(record) => `${record.accountName}`}
        secondaryText={(record) => `${record.assignedTo}`}
        tertiaryText={(record) => (
          <AuditProgressBar label="Progress" record={record} {...props} />
        )}
        linkType="edit"
        rightIcon={() => (
          <ChevronRightIcon
            fontSize="large"
            color="secondary"
            style={{ marginLeft: 40, marginTop: 10 }}
          />
        )}
      />
    ) : isSmall ? (
      <Datagrid rowClick="edit">
        <DateField
          source="createDateTime"
          label="Create Date"
          sortable={true}
        />
        <TextField source="accountName" label="Account" sortable={false} />
        <TextField source="assignedTo" label="Assigned To" sortable={false} />
        <AuditProgressBar {...props} label="Progress" sortable={false} />
      </Datagrid>
    ) : (
      <Datagrid rowClick="edit">
        <DateField
          source="createDateTime"
          label="Create Date"
          sortable={true}
        />
        <AuditProgressBar {...props} label="Progress" sortable={false} />
        <TextField source="accountName" label="Account" sortable={false} />
        <TextField source="assignedTo" label="Assigned To" sortable={false} />
        <EditButton />
      </Datagrid>
    );
};
